export default __webpack_public_path__ + "static/media/non-household-1.319091bd.jpg";